module.exports = __webpack_public_path__ + "static/media/Barlow-Bold.72871854.ttf";